import { z } from "zod/v3";
import { Point } from "@opstel/geo/Point";
import { Point as ProtoPoint } from "@opstel/gen/knop/ui/v1/model/point_pb";
import { PlainMessage } from "@bufbuild/protobuf";

type PointSchema = z.ZodType<Point, z.ZodTypeDef, PlainMessage<ProtoPoint>>;
export const pointSchema: PointSchema = z
  .object({
    x: z.number(),
    y: z.number(),
  })
  .transform(({ x, y }) => new Point(x, y)) satisfies PointSchema;
